import React from 'react';
import s from './QuickActionButton.module.css';

export function QuickActionButton(props) {
    const { buttonText } = props;

    return <div className={s.quickActionButton}>{buttonText}</div>;
}
